const Rota = () => {
  return (
    <svg
      width="144"
      height="144"
      viewBox="0 0 144 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
      <g clipPath="url(#clip0_3699_12536)">
        <path
          d="M43.7174 46.9351H100.783C101.371 46.9351 101.935 47.1687 102.351 47.5845C102.766 48.0004 103 48.5644 103 49.1524V100.783C103 101.371 102.766 101.935 102.351 102.351C101.935 102.767 101.371 103 100.783 103H43.7174C43.1293 103 42.5653 102.767 42.1495 102.351C41.7336 101.935 41.5 101.371 41.5 100.783V49.1524C41.5 48.5644 41.7336 48.0004 42.1495 47.5845C42.5653 47.1687 43.1293 46.9351 43.7174 46.9351Z"
          fill="#E6E6E6"
          stroke="#BFBFBF"
        />
        <path
          d="M72.251 93.9891C72.43 93.9893 72.6072 93.9541 72.7725 93.8855C72.9378 93.817 73.088 93.7164 73.2143 93.5897L83.4902 83.2772C84.9846 81.78 85.8289 79.7543 85.8402 77.6389C85.8516 75.5236 85.029 73.4889 83.5507 71.9758C82.0725 70.4627 80.0575 69.593 77.9425 69.555C75.8274 69.5171 73.7826 70.314 72.251 71.7731C70.7193 70.3139 68.6743 69.517 66.5591 69.5551C64.4439 69.5931 62.4289 70.4631 60.9507 71.9766C59.4725 73.49 58.6502 75.5249 58.6619 77.6404C58.6736 79.7559 59.5184 81.7816 61.0133 83.2785L71.2877 93.591C71.4142 93.7175 71.5644 93.8178 71.7297 93.8861C71.895 93.9545 72.0722 93.9895 72.251 93.9891Z"
          fill="#E86C60"
        />
        <path
          d="M43.7174 46.4351H100.783C101.503 46.4351 102.194 46.7214 102.704 47.231C103.214 47.7406 103.5 48.4318 103.5 49.1524V60.022H41V49.1524C41 48.4318 41.2863 47.7406 41.7959 47.231C42.3055 46.7214 42.9967 46.4351 43.7174 46.4351Z"
          fill="#E86C60"
        />
        <path
          d="M91.273 53.2283V42.3587C91.273 41.9983 91.1299 41.6528 90.8751 41.398C90.6203 41.1431 90.2747 41 89.9143 41H87.197C86.8366 41 86.491 41.1431 86.2362 41.398C85.9814 41.6528 85.8383 41.9983 85.8383 42.3587V53.2283C85.8383 53.5886 85.9814 53.9342 86.2362 54.189C86.491 54.4438 86.8366 54.587 87.197 54.587H89.9143C90.2747 54.587 90.6203 54.4438 90.8751 54.189C91.1299 53.9342 91.273 53.5886 91.273 53.2283Z"
          fill="#444444"
        />
        <path
          d="M58.6644 53.2283V42.3587C58.6644 41.9983 58.5212 41.6528 58.2664 41.398C58.0116 41.1431 57.666 41 57.3057 41H54.5883C54.228 41 53.8824 41.1431 53.6276 41.398C53.3728 41.6528 53.2296 41.9983 53.2296 42.3587V53.2283C53.2296 53.5886 53.3728 53.9342 53.6276 54.189C53.8824 54.4438 54.228 54.587 54.5883 54.587H57.3057C57.666 54.587 58.0116 54.4438 58.2664 54.189C58.5212 53.9342 58.6644 53.5886 58.6644 53.2283Z"
          fill="#444444"
        />
      </g>
      <defs>
        <clipPath id="clip0_3699_12536">
          <rect
            width="62.5"
            height="62.5"
            fill="white"
            transform="translate(41 41)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Rota
